export { HdpAuthor } from "./pages/hdpAuthor";
export { HdpAddAuthor } from "./pages/hdpaddAuthor";
